import ComingSoon from "app/components/common/ComingSoon";
import React from "react";

const Alumni = () => {
  return <ComingSoon />;
};

export default Alumni;
